import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { Icon, type BeeGlyphName } from './icons/Icon';
import { homePath } from '../utils/clientReview';
interface NavItem {
  to: string;
  key: string;
  glyph: BeeGlyphName;
  /** Extra path prefixes that belong to this tab. */
  match: string[];
  emphasis?: boolean;
}

/**
 * Five destinations. Publishing is not a tab: it lives in the contextual "+"
 * inside Community. Check is the central product action and carries the
 * subtle Honey Gold emphasis.
 */
const items: NavItem[] = [{
  to: '/',
  key: 'nav.home',
  glyph: 'home',
  match: []
}, {
  to: '/comunidade',
  key: 'nav.community',
  glyph: 'community',
  match: ['/comunidade', '/feed', '/explore', '/busca', '/post', '/u/', '/novo', '/publicado']
}, {
  to: '/check',
  key: 'nav.check',
  glyph: 'check',
  match: ['/check'],
  emphasis: true
}, {
  to: '/stats',
  key: 'nav.progress',
  glyph: 'progress',
  match: ['/stats']
}, {
  to: '/perfil',
  key: 'nav.profile',
  glyph: 'profile',
  match: ['/perfil', '/config', '/notificacoes', '/estados', '/estado']
}];
export function BottomNavigation() {
  const {
    t
  } = useLocale();
  const {
    pathname
  } = useLocation();
  const home = homePath();
  const isActive = (item: NavItem) => item.to === '/' ? pathname === '/' || pathname === '/index' : item.match.some(prefix => pathname.startsWith(prefix));
  return <nav aria-label={t('nav.aria')} className="sticky bottom-0 z-40 border-t border-white/5 bg-deep pb-[calc(env(safe-area-inset-bottom)+12px)] pt-[10px] shadow-nav" data-id="element-505" data-mp="38ikwjfl9znaj">
      <ul className="flex items-stretch px-[6px]" data-id="element-506" data-mp="2you8ucwz3gvw">
        {items.map(item => {
        const active = isActive(item);
        return <li key={item.to} className="flex-1" data-id="element-507" data-mp="wvmtj3hd0za0">
              <NavLink to={item.to === '/' ? home : item.to} aria-current={active ? 'page' : undefined} className="flex min-h-[52px] flex-col items-center justify-start gap-[6px] px-[2px]" data-id="element-508" data-mp="wtadivv5wyzl">
                <span className={`grid h-[30px] w-[30px] place-items-center rounded-pill transition-colors duration-150 ease-brand ${item.emphasis ? active ? 'bg-gold text-deep' : 'border border-gold/55 bg-gold/15 text-gold' : active ? 'text-gold' : 'text-ondark'}`} data-id="element-509" data-mp="2r3idqbuckb7x">
                  <Icon name={item.glyph} size={item.emphasis ? 'md' : 'nav'} data-id="element-510" data-mp="2w2uxgnpx926a" />
                </span>
                <span className={`whitespace-nowrap text-[10px] font-medium ${active ? 'text-sand' : 'text-ondark'}`} data-id="element-511" data-mp="303do4eg2w26w">
                  {t(item.key)}
                </span>
              </NavLink>
            </li>;
      })}
      </ul>
    </nav>;
}